// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_RouteAsURL from "../Restaumatic.RouteAsURL/index.js";
import * as Unscramble from "../Unscramble/index.js";
var CouponId = function (x) {
    return x;
};
var CouponAssignmentId = function (x) {
    return x;
};
var udecodeCouponId = Unscramble.decodeInt1;
var udecodeCouponAssignmentId = Unscramble.decodeInt1;
var showCouponId = Data_Show.showInt;
var showCouponAssignmentId = Data_Show.showInt;
var ordCouponId = Data_Ord.ordInt;
var ordCouponAssignmentId = Data_Ord.ordInt;
var newtypeCouponId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCouponAssignmentId = {
    Coercible0: function () {
        return undefined;
    }
};
var eqCouponId = Data_Eq.eqInt;
var eqCouponAssignmentId = Data_Eq.eqInt;
var encodeCouponId = Foreign_Generic_Class.intEncode;
var encodeCouponAssignmentId = Foreign_Generic_Class.intEncode;
var decodeCouponId = Foreign_Generic_Class.intDecode;
var decodeCouponAssignmentId = Foreign_Generic_Class.intDecode;
var asParamCouponId = Restaumatic_RouteAsURL.asParamInt;
var asParamCouponAssignmentId = Restaumatic_RouteAsURL.asParamInt;
export {
    CouponId,
    newtypeCouponId,
    showCouponId,
    eqCouponId,
    ordCouponId,
    encodeCouponId,
    decodeCouponId,
    udecodeCouponId,
    asParamCouponId
};
